import { render } from "./HeaderNew.vue?vue&type=template&id=1b706bc6&scoped=true"
import script from "./HeaderNew.vue?vue&type=script&lang=js"
export * from "./HeaderNew.vue?vue&type=script&lang=js"

import "./HeaderNew.vue?vue&type=style&index=0&id=1b706bc6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b706bc6"]])

export default __exports__